/** Типы аналитических отчётов LTMS (ключи API) и пункты меню/главной. */

/**
 * Имя Vue Router-маршрута для раздела аналитики.
 * @returns {string}
 */
export function analyticsRouteName() {
  return 'analytics.list'
}

export const ANALYTICS_REPORT_TYPES = [
  {
    id: 'strategic_portfolio',
    hasChart: true,
    usesPeriod: true,
    periodMode: 'range',
    requiresProduct: false,
    icon: 'bi bi-bar-chart-fill',
    tone: 'purple',
    labelKey: 'reports.strategicPortfolio',
  },
  {
    id: 'annual_plan',
    hasChart: true,
    usesPeriod: false,
    usesYear: true,
    periodMode: 'year',
    requiresProduct: false,
    icon: 'bi bi-cloud-arrow-down-fill',
    tone: 'teal',
    labelKey: 'reports.annualPlan',
  },
  {
    id: 'registered_portfolio',
    hasChart: true,
    usesPeriod: true,
    periodMode: 'range',
    requiresProduct: false,
    icon: 'bi bi-clock-fill',
    tone: 'green',
    labelKey: 'reports.registeredPortfolio',
  },
  {
    id: 'monitoring_new_registration',
    hasChart: true,
    usesPeriod: true,
    periodMode: 'range',
    requiresProduct: false,
    icon: 'bi bi-graph-up',
    tone: 'orange',
    labelKey: 'reports.monitoringNewReg',
  },
  {
    id: 'monitoring_line_extension',
    hasChart: true,
    usesPeriod: true,
    periodMode: 'range',
    requiresProduct: false,
    icon: 'bi bi-bar-chart-line-fill',
    tone: 'purple',
    labelKey: 'reports.monitoringExtension',
  },
  {
    id: 'monitoring_new_indication',
    hasChart: true,
    usesPeriod: true,
    periodMode: 'range',
    requiresProduct: false,
    icon: 'bi bi-bar-chart-steps',
    tone: 'teal',
    labelKey: 'reports.monitoringNewIndication',
  },
  {
    id: 'monitoring_lr',
    hasChart: true,
    usesPeriod: true,
    periodMode: 'range',
    requiresProduct: false,
    icon: 'bi bi-bar-chart',
    tone: 'gray',
    labelKey: 'reports.monitoringRenewal',
  },
  {
    id: 'monitoring_geographic_extension',
    hasChart: true,
    usesPeriod: true,
    periodMode: 'range',
    requiresProduct: false,
    icon: 'bi bi-bar-chart-line',
    tone: 'green',
    labelKey: 'reports.monitoringGeography',
  },
  {
    id: 'monitoring_commitments',
    hasChart: true,
    usesPeriod: true,
    periodMode: 'range',
    requiresProduct: false,
    icon: 'bi bi-bar-chart',
    tone: 'red',
    labelKey: 'reports.monitoringCommitments',
  },
  {
    id: 'product_card',
    hasChart: false,
    usesPeriod: false,
    requiresProduct: true,
    icon: 'bi bi-file-earmark-medical',
    tone: 'purple',
    labelKey: 'reports.productCard',
  },
]

/** Явный список типов, доступных для quick-report со стартовой страницы. */
export const HOME_ANALYTICS_REPORT_IDS = new Set([
  'strategic_portfolio',
  'annual_plan',
  'registered_portfolio',
  'monitoring_new_registration',
  'monitoring_line_extension',
  'monitoring_new_indication',
  'monitoring_lr',
  'monitoring_geographic_extension',
  'monitoring_commitments',
])

/**
 * Проверяет, можно ли запускать тип отчёта со стартовой страницы.
 * @param {object} item Метаданные типа аналитического отчёта.
 * @returns {boolean} true, если quick-report может открыть PDF со встроенным графиком.
 */
export function isHomeAnalyticsReportType(item) {
  return (
    HOME_ANALYTICS_REPORT_IDS.has(item?.id) &&
    Boolean(item?.hasChart) &&
    !item?.requiresProduct
  )
}

/** Отчёты на стартовой странице: только типы с графиком и без выбора препарата. */
export const HOME_ANALYTICS_REPORTS = ANALYTICS_REPORT_TYPES.filter(
  isHomeAnalyticsReportType
).map(item => ({
  key: item.id,
  labelKey: item.labelKey,
  icon: item.icon,
  tone: item.tone,
  usesPeriod: item.usesPeriod,
  routeName: analyticsRouteName(),
  routeQuery: { reportType: item.id },
}))

/** Статусы формирования отчёта (как на backend). */
export const ANALYTICS_REPORT_STATUS = {
  pending: 1,
  processing: 2,
  done: 3,
  error: 4,
}

/**
 * Возвращает метаданные типа отчёта по ключу.
 * @param {string} reportType
 * @returns {object|undefined}
 */
export function getAnalyticsReportTypeMeta(reportType) {
  return ANALYTICS_REPORT_TYPES.find(item => item.id === reportType)
}
